var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.country,
          expression: "country",
        },
      ],
      attrs: { name: "country" },
      on: {
        change: [
          function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.country = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          _vm.updateCountry,
        ],
      },
    },
    _vm._l(_vm.countries, function (country) {
      return _c("option", { domProps: { value: country } }, [
        _vm._v(_vm._s(country.name)),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }